<template>
    <div class="m15 page_logo" ref="body" style="page-break-before: always;" id="composicao">
        <hr />
        <div class="site"></div>
        <h4 class="simulator-title loaded">{{ titulo }}</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>

        <template v-if="cliente.patrimonio && composicao_patrimonial_grafico.length > 1">
            <div>
                <pie-chart2 ref="barchat" :myData="composicao_patrimonial_grafico" v-show="false" />
                <img :src="image" height="280" style="display: block; margin: 0 auto">
                <div class="block" style="margin-bottom: 30px">
                    <div align="center">Patrimônio Total</div>
                    <div class="total" align="center">Total: {{ patrimonio.soma | dinheiro }}</div>
                </div>
            </div>

            <div class="texto">
                Neste primeiro gráfico apresentamos a composição do seu patrimônio, que é fundamental para analisar eventuais encargos quando o assunto é a transmissão patrimonial.
            </div>
        </template>

        <div class="texto" style="text-align:justify">
            Em um eventual processo de <b style="font-weght:bold;">transmissão do patrimônio</b> por herança, levando em consideração a carga de tributação atual, no seu estado de domicílio, carga tributária essa que está sujeita à um considerável aumento visto que temos transcorrendo no Congresso Nacional dois projetos de lei propondo o aumento da alíquota para aproximadamente 25% {{ composicao_patrimonial_grafico.length > 1?' , a situação seria a seguinte:' : '.'}}
        </div>

        <div class="col l3 s12"></div>
        <div class="col l6 s12">
            <table class="striped print-table print-table-striped bordered text-center">
                <thead>
                    <tr class="print-table-text-center">
                        <th>NOME</th>
                        <th>PORCENTAGEM</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="print-table-text-center">
                        <td><strong>ITCMD</strong></td>
                        <td>{{ patrimonio.imposto_itcd || 0 }}%</td>
                        <td>{{ patrimonio.soma * patrimonio.imposto_itcd * 0.01 | dinheiro }}</td>
                    </tr>
                    <tr class="print-table-text-center">
                        <td><strong>Honorário Advogado</strong></td>
                        <td>{{ patrimonio.advogados || 0 }}%</td>
                        <td>{{ patrimonio.soma * patrimonio.advogados * 0.01 | dinheiro }}</td>
                    </tr>
                    <tr class="print-table-text-center">
                        <td><strong>Custo Administrativo</strong></td>
                        <td>{{ patrimonio.custos_judiciais  || 0 }}%</td>
                        <td>{{ patrimonio.soma * patrimonio.custos_judiciais * 0.01 | dinheiro }}</td>
                    </tr>
                    <tr class="text-primary print-text-primary print-table-text-center">
                        <td><strong>Patrimônio Líquido</strong></td>
                        <td>{{ 100 - (patrimonio.imposto_itcd + patrimonio.advogados  + patrimonio.custos_judiciais)  }}%</td>
                        <td>{{ patrimonio.patrimonio_liquido | dinheiro }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row">
            <div class="col l12 s12">
                <div class="row">
                <div class="col l12 s12">
                    <div class="texto" style="text-align:justify">
                        Ou seja, dos {{ patrimonio.soma | dinheiro }} ({{ currency(patrimonio.soma) }}) atuais, somente {{ patrimonio.patrimonio_liquido | dinheiro }}  ({{ currency(patrimonio.patrimonio_liquido) }}) chegariam até as mãos de seus herdeiros,
                        em um processo de inventário com um custo de tramitação de {{ patrimonio.custos_patrimonio | dinheiro }} ({{ currency(patrimonio.custos_patrimonio) }})

                        <!-- igual a zero -->
                        <span v-if="patrimonio.custos_patrimonio == 0">, além da morosidade, teria um custo estimado de {{ patrimonio.custos_patrimonio | dinheiro }} ({{ currency(patrimonio.custos_patrimonio) }})</span>.
                    </div>
                </div>
                </div>
                <div class="row">
                    <div class="col l12 s12">
                        <div class="texto" style="text-align:justify; font-weight: bold;">Existem 3 alternativas para custeio de um eventual processo de inventário, vejamos:</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col l12 s12">
                        <ol style="padding: 0">
                            <li>Você assume essa responsabilidade, provisionando esse valor em um investimento com liquidez imediata e que não tenha a incidência no processo de inventário.</li>
                            <li>Você transfere esse custo para os seus herdeiros, deixando que eles assumam essas despesas no processo de inventário. Sendo essa a opção escolhida sugerimos que já comunique aos herdeiros a necessidade de formação de reserva com liquidez para essa finalidade, evitando que a falta de uma reserva traga prejuízos, comuns, como a venda de patrimônio em valores abaixo do preço de mercado ou a tomada de empréstimos a juros exorbitantes.</li>
                            <li>Você terceiriza esse custo para uma seguradora, o que acreditamos ser mais inteligente, contratando uma apólice de Seguro de Vida, já que a indenização não entra em processo de inventário, não responde por dívidas pessoais e não há tributação sobre o valor segurado, além do que o custo é muito baixo em relação aos benefícios e a liquidez é imediata.</li>
                        </ol>

                        <div v-if="empresa_selecionada && empresa_selecionada.empresa_nome_fantasia.toLowerCase().includes('oabprev')" class="texto">
                            Na OABPrev MG a cobertura de pecúlio por morte é uma das melhores e mais inteligentes opções do mercado.
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
    import { utils } from "../relatorios/mixins/index";
    import PieChart from '@/components/canvas-chart/PieChart'
    import PieChart2 from '@/components/canvas-chart/PieChart2'
    import Saudacao from './Saudacao'
    export default {
        name:'SucessaoPatrimonial',
        mixins: [utils],
        components:{
            PieChart,
            PieChart2,
            Saudacao
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
            empresa_selecionada: {
                type: Object,
                default: null
            }
        },

        computed: {

            patrimonio() {
                return this.cliente.patrimonio;
            },


            composicao_patrimonial_grafico() {

                const patrimonio = this.patrimonio;

                const data = [
                    { label:'Imóveis', value: patrimonio.imoveis },
                    { label:'Veículos', value: patrimonio.veiculos },
                    { label:'Investimentos', value: patrimonio.investimentos },
                    { label:'Maquinas/Equip', value: patrimonio.maquinas_equipamentos },
                    { label:'Saldos\nBancários', value: patrimonio.saldos_bancarios },
                    { label: 'Particip. Societ.', value: patrimonio.participacoes_societarias },
                    { label:'Outros', value: patrimonio.outros }
                ];

                // O gráfico só fica na ordem se colocar isso :eyes:

                data.reverse()

                return data.filter(item => !!item.value)
            },


        },
        data () {
            return {

                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',

                titulo: 'Composição Patrimonial',
            }
        },
        methods:{
            async plot()
            {
                return this.$refs.body.outerHTML;
            },

            jsonToObject(j){
                return Object.keys(j).map(function(_) { return j[_]; })
            }
        },
        async mounted () {

            await this.$nextTick()

            if (this.$refs.barchat) {
                this.image = this.$refs.barchat.$el.toDataURL("image/png");
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";


.text-center{
    text-align: center;

    th, td{
        text-align: center;
    }
}


.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
ol {
    li {
        margin-bottom: 20px;
    }
}

ol li {
    display: flex;
    align-items: flex-start;
    counter-increment: item;
}
ol li:before {
    content: counter(item) " ";
    background: var(--color-primary);
    font-weight: bold;
    color:#fff;
    box-sizing: border-box;
    display: block;
    min-width: 32px;
    text-align: center;
    padding: 5px;
    margin: 5px;
}

@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 100%;
    }
}
@media (min-width: 768px) and (max-width:938px){
    .block{

    }
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/SucessaoPatrimonial.vue